class ScrollDownComponent extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.scroll-down__toggle').addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    this.init();
  }

  init() {
    const containerHeight = this.closest(this.dataset.container).scrollHeight;
    const headerHeight = document.querySelector('.header-wrapper').offsetHeight;
    const announcementHeight = Array.from(
      document.querySelectorAll('announcement-bar, secondary-announcement-bar')
    ).reduce((total, bar) => total + bar.offsetHeight, 0);
    const contentHeight =
      headerHeight && announcementHeight ? containerHeight - headerHeight + announcementHeight : containerHeight;
    scrollTo({top: contentHeight, behavior: 'smooth'});
  }
}

customElements.define('scroll-down-component', ScrollDownComponent);
